import React, {useState, useEffect, useRef} from "react";
import OwlNav from "../../../components/shared/OwlNav";
import { IsEmpty, convertSlugToTitle, generateStructuredData } from "../../../util/commonFunctions";
import HelmetComponent from "../../../components/shared/Helmet";
import { prependHttpsIfProtocolNotPresent } from "../../../util/url";
import { getEnv } from "../../../../helpers/env";

function Navigation({ listing = [], title = "", pathName, onTierClicked = () => {}, followCompanyClicked = () => {}, isFollowing, unFollowCompanyClicked = () => {}, redirectToCompanyPage = () => {}, contentArr=[] }) {
  function getPathFromUrl(url) {
    const removeQuery = url && url.split("?")[0];
    return removeQuery;

  }
  const [height, setHeight] = useState(0);
  const [canonicalUrl, setCanonicalUrl] = useState(null);
  const [structuredData, serStructuredData] = useState(null);
  const ref= useRef(null)

  const getTnChtml = (content) => {
    if (!content){
      return {
        __html: ""
      }
    }
    console.log("Expert content:", content);
    content = content.replace('<p><br></p>', '');
    content = content.replace(/<p/g, '<p class="description" ');
    content = content.replace(/<a/g, '<a class="custom_links_webinar" ');
    content = content.replace(/<li/g, '<li class="default_listing description" ');
    content = content.replace(/<ul/g, '<ul class="default_listing" ');
    content = content.replace(/<ol/g, '<ol class="default_listing" ');
    content = content.replace(/<img/g, '<img class="responsive-img" ');
    return {
      __html: content
    };
  };
  
  useEffect(() => {
    const structuredData = generateStructuredData(contentArr);
    structuredData && serStructuredData(`{"@context":"https://schema.org", "@graph": [${structuredData}]}`);
  },[contentArr])

  useEffect(() => {
    const canonicalUrl = getEnv('BASE_URL') + window.location.pathname + `?expertID=${title?.id}`;
    setCanonicalUrl(canonicalUrl);
    setTimeout(() => {
      setHeight(ref?.current?.clientHeight)
    }, 1000)
  })
  const url = pathName && pathName.substring(pathName.lastIndexOf('/') + 1)
  const finalUrl = getPathFromUrl(url)

  const toggleText = () => {
    let descHgt = document.querySelector('.company-info-toggle');
    let infoHeight = descHgt.scrollHeight;
    let btnText = document.querySelector(".toggle-text");
    if (btnText.innerHTML === "show more") {
      btnText.innerHTML = "show less";
    } else {
      btnText.innerHTML = "show more";
    }
    descHgt.style.setProperty('--max-height', infoHeight + 'px');
    descHgt.classList.toggle("is-visible");
  }
  
  return (
    <React.Fragment>
      <HelmetComponent
        title={
          ((finalUrl && convertSlugToTitle(finalUrl)) ||
            (title && title.name)) + " | ausbiz"
        }
        subject={
          (finalUrl && convertSlugToTitle(finalUrl)) ||
          (title && title.name) ||
          (title && title.name)
        }
        customDescription={ (title && title.expertRoles && title.companyName) ? `${title.expertRoles} at ${title.companyName} | ausbiz expert` :  null}
        description={ (title && title.expertRoles && title.companyName) ? `${title.expertRoles} at ${title.companyName} | ausbiz expert` :  null}
        canonicalUrl={canonicalUrl}
        structuredData={structuredData}
        noIndex="false"
      />
      <div className="navigation-title-wrap">
        <div className="container">
          <div className="navigation-title-img-block">
            <div className="navigation-title-img navigation-circle-img">
              <img src={title && title.photo ? title && title.photo : "/assets/svg/abiz_placeholder.svg"} className="navigation-title-img" />
            </div>
            <div className="navigation-title-right">
              <div className="navigation-title navigation-expert-title">
              {title != null && (
                  <h1>
                    {title && title.name}
                  </h1>
                )}
                    <div className="experts-extra-info hide-mobile">
                      <div className="expert-follow-btns">
                {title != null ? (
                  isFollowing ? (
                    <a
                      href="javascript:void(null);"
                      onClick={() => unFollowCompanyClicked()}
                      className="unfollow-btn"
                    >
                      Following
                    </a>
                  ) : (
                    <a
                      href="javascript:void(null);"
                      onClick={() => followCompanyClicked()}
                      className="follow-btn"
                    >
                      Follow
                    </a>
                  )
                ) : null}
                      </div>
                      <div className="expert-social">
                        <ul>
                          {title && title.linkedInURL && <li><a href={prependHttpsIfProtocolNotPresent(title?.linkedInURL)} target="_blank" className="linkedin"></a></li>}
                          {title && title.twitterURL && <li><a href ={prependHttpsIfProtocolNotPresent(title?.twitterURL)} target="_blank" className="twitter"></a></li>}
                        </ul>
                      </div>
                    </div>
                </div>
                <div className="expert-position">
                  <ul>
                    {title && title.expertRoles && <li>{title && title.expertRoles}</li>} 
                  {title && title.companyProfile ? <li><a
                    href="javascript:void(null);"
                    onClick={event => {
                      if (title?.companyProfile) {
                        redirectToCompanyPage(event)
                      }
                    }}
                  >{title && typeof title.companyName === 'string' && title.companyName}</a></li>
                    :
                    <li>{title && typeof title.companyName === 'string' && title.companyName}</li>
                  }
                  </ul>
                </div>
                <div className="experts-extra-info show-mobile">
                  <div className="expert-follow-btns">
                  {title != null ? (
                  isFollowing ? (
                    <a
                      href="javascript:void(null);"
                      onClick={() => unFollowCompanyClicked()}
                      className="unfollow-btn"
                    >
                      Following
                    </a>
                  ) : (
                    <a
                      href="javascript:void(null);"
                      onClick={() => followCompanyClicked()}
                      className="follow-btn"
                    >
                      Follow
                    </a>
                  )
                ) : null}
                  </div>
                  <div className="expert-social">
                    <ul>
                    {title && title.linkedInURL && <li><a href={prependHttpsIfProtocolNotPresent(title?.linkedInURL)} target="_blank" className="linkedin"></a></li>}
                    {title && title.twitterURL && <li><a href ={prependHttpsIfProtocolNotPresent(title?.twitterURL)} target="_blank" className="twitter"></a></li>}
                    </ul>
                  </div>
                </div>
              <div className="navigation-info">
                <div className={title != null && height >= 40 ? "company-info-toggle company-info-active" : "company-info-toggle"} ref={ref}>
                <p>
                    {title && title.about && !IsEmpty(title.about) &&
                      <span dangerouslySetInnerHTML={getTnChtml(title.about)} ></span>
                    }
                </p>
              </div>
                {title != null && height >= 40 && <span className="toggle-text" onClick={toggleText}>show more</span>}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="nav-links random-nav-change">
        <div className="container">
          {!IsEmpty(listing) && Array.isArray(listing) && (
            <OwlNav data={listing} onTierClicked={onTierClicked} isCompanyPage={true} isExpertPage={true} />
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export { Navigation };